module.exports = __webpack_public_path__ + "media/src/images/logo_s-577ce39338dab0920f5cb4260065092a.png";